import _ from "lodash";
import React, { Component } from "react";
import PropTypes from "prop-types";
import { FormattedMessage, injectIntl } from "react-intl";
import { connect } from "react-redux";
import classnames from "classnames";

import { Button } from "../../components/button/Button";
import { WizardProfiles } from "../profiles/WizardProfiles";
import { withLayout } from "../../components/layout/Layout";
import { GoBack } from "../../components/goBack/goBack";
import { getSpson, isSpsonEnabled } from "../../store/account";
import {
  setInitialProfiles,
  setSelectedProfile as setSelected,
} from "../../store/profiles/profiles.actions";
import {
  getWizardSelectedProfileId,
  getVisibleProfiles,
  getVisibleProfilesWithKeys,
} from "../../store/profiles/profiles.selectors";
import { AriaPageTitle } from "../../components/ariaPageTitle";
import { finishWizardSetup } from "../../store/wizard/wizard.actions";
import { getDeepLink } from "../../store/root.selectors";

import "./WizardPage.scss";

class WizardPageComponent extends Component {
  className = "wizard-page";

  componentDidMount() {
    this.props.getSpson();
    this.props.setInitialProfiles();
  }

  render() {
    const {
      profiles,
      hasAvailableProfiles,
      limit,
      selectedProfile,
      setSelectedProfile,
      customProfilesAmount,
      isSingle,
      isSpsonEnabled,
      finishSetup,
    } = this.props;

    const wizardClasses = classnames(this.className, {
      [`${this.className}--single`]: isSingle,
    });
    const finishLabelId = isSpsonEnabled
      ? "continue_setup"
      : "complete_onboarding";

    return (
      <div className={wizardClasses}>
        <AriaPageTitle pageKey="page_title_wizard_protection_preferences" />
        <GoBack url={"/wizard/protection-choice"} />
        {
          // TODO: Consider setting profiles outside of this component
          //   since currently `componentDidMount` is called after children's
          //   so we always have at least one unneeded remount
          hasAvailableProfiles && (
            <WizardProfiles
              profiles={profiles}
              limit={limit}
              selected={selectedProfile}
              onSelect={setSelectedProfile}
              customProfilesAmount={customProfilesAmount}
            />
          )
        }
        <div className="wizard-page__btn-container">
          <Button
            className="wizard-page__action-btn"
            onClick={finishSetup}
            size={"large"}
          >
            <FormattedMessage id={finishLabelId} />
          </Button>
        </div>
      </div>
    );
  }
}

WizardPageComponent.propTypes = {
  hasAvailableProfiles: PropTypes.bool.isRequired,
  selectedProfile: PropTypes.string,
  setInitialProfiles: PropTypes.func.isRequired,
  setSelectedProfile: PropTypes.func.isRequired,
  getSpson: PropTypes.func.isRequired,
  finishSetup: PropTypes.func.isRequired,
  customProfilesAmount: PropTypes.number.isRequired,
  isSingle: PropTypes.bool,
};

export const WizardPage = _.flowRight(
  withLayout({
    showHeaderUnderline: true,
    showNavigation: false,
    showUserInfo: false,
    showLogOutLink: true,
  }),
  injectIntl,
  connect(
    (state) => ({
      hasAvailableProfiles: !_.isEmpty(getVisibleProfiles(state)),
      limit: state.profiles.limit,
      selectedProfile: getWizardSelectedProfileId(state),
      customProfilesAmount: state.profiles.changed.keys.length - 3,
      profiles: getVisibleProfilesWithKeys(["id", "name", "type"])(state),
      isSpsonEnabled: isSpsonEnabled(state),
      deepLink: getDeepLink(state),
    }),
    (dispatch, { isSingle }) => ({
      getSpson: () => dispatch(getSpson()),
      setInitialProfiles: () => dispatch(setInitialProfiles({ isSingle })),
      finishSetup: () => dispatch(finishWizardSetup(isSingle)),
      setSelectedProfile: (id) => dispatch(setSelected(id)),
    })
  )
)(WizardPageComponent);
